<template>
  <v-col :cols="cols">
    <div v-if="editable && !readOnly" class="mx-4 mt-n4">
      <v-select
        v-if="select"
        dense
        filled
        hide-details
        :label="title"
        style="height:29px;"
        v-model="info"
        :items="items"
        class="my-5"
        @input="$emit('update:info', info)"
      />
      <v-text-field
        v-else
        dense
        filled
        :rules="activeRules"
        :label="title"
        v-model="info"
        style="height:29px;"
        class="my-5"
        @input="$emit('update:info', info)"
      />
    </div>
    <div v-else class="mx-4">
      <span class="px-2" style="font-size: 12px;">{{ title }}</span>
      <slot>
        <div
          class="d-flex align-center text-capitalize text-truncate px-2"
          style="border-bottom: solid 1px black; height:29px;"
        >
          <h2 v-if="type === 'title'">
            {{ info }}
          </h2>
          <h3 v-else-if="vistar">
            {{ vistarInfo }}
          </h3>
          <h3 v-else-if="title === 'Launch Mode'">{{ formatLaunch }}</h3>
          <h3 v-else>
            {{ info && info.text ? info.text : info }}
          </h3>
        </div>
      </slot>
    </div>
  </v-col>
</template>
<script>
import { MobileView } from '@/mixins';
import GroupDetailData from '@/mixins/GroupDetailData';

export default {
  props: {
    info: [String, Number, Object],
    title: String,
    type: String,
    select: Boolean,
    items: Array,
    phone: Boolean,
    cols: Number,
    readOnly: Boolean,
    nameTaken: Boolean,
    vistar: Boolean,
  },
  data() {
    return {
      rules: {
        phoneLength: v =>
          /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v) ||
          'Please enter a valid 10 digit phone number',
        duplicateName: () =>
          !this.nameTaken || 'This name has already been taken',
      },
    };
  },
  mixins: [MobileView, GroupDetailData],
  computed: {
    activeRules() {
      if (this.phone) {
        return [this.rules.phoneLength];
      }
      if (this.title === 'Course Name') {
        return [this.rules.duplicateName];
      }
      return [];
    },
    vistarInfo() {
      switch (this.info) {
        case 0:
          return 'No Vistar';
        case 1:
          return 'Vistar Normal';
        case 2:
          return 'Vistar Direct';
        default:
          return '';
      }
    },
    formatLaunch() {
      switch (this.info) {
        case 'b2b':
        case 'interface_select_bt':
          return 'Bluetooth';
        case 'interface_select':
          return 'Select';
        case 'interface_select_plus':
          return 'Select+';
        case 'interface_select_plus_plus':
          return 'Select++';
        case 'interface_prime':
          return 'Prime';
        default:
          return '';
      }
    },
  },
};
</script>
